import { z } from 'zod';
const TokenInfoSchema = z.object({
    id: z.string(),
    address: z.string(),
    cmcId: z.number(),
    decimals: z.number(),
    name: z.string(),
    symbol: z.string(),
    totalSupply: z.string(),
    socialLinks: z.any(),
    info: z.object({
        circulatingSupply: z.union([z.string(), z.undefined()]),
        imageThumbUrl: z.string(),
    }),
    explorerData: z.object({
        blueCheckmark: z.union([z.boolean(), z.undefined()]),
        description: z.union([z.string(), z.undefined()]),
        tokenType: z.union([z.string(), z.undefined()]),
    }),
    networkId: z.number(),
});
const FilterTokenResultSchema = z.object({
    volume1: z.string(),
    volume4: z.string(),
    volume12: z.string(),
    volume24: z.string(),
    liquidity: z.string(),
    marketCap: z.string(),
    priceUSD: z.string(),
    buyCount1: z.number(),
    change1: z.string(),
    change4: z.string(),
    change12: z.string(),
    change24: z.string(),
    high24: z.string(),
    low24: z.string(),
    sellCount24: z.number(),
    buyCount24: z.number(),
    holders: z.number(),
    createdAt: z.number(),
});
const TokenPriceSchema = z.object({
    address: z.string(),
    networkId: z.number(),
    priceUsd: z.number(),
});
const TPairInfoStatsSchema = z.object({
    buyVolume: z.object({
        currentValue: z.number(),
        previousValue: z.number(),
    }),
    sellVolume: z.object({
        currentValue: z.number(),
        previousValue: z.number(),
    }),
    volume: z.object({
        currentValue: z.number(),
        previousValue: z.number(),
    }),
    transactions: z.object({
        currentValue: z.number(),
        previousValue: z.number(),
    }),
    buys: z.object({
        currentValue: z.number(),
        previousValue: z.number(),
    }),
    sells: z.object({
        currentValue: z.number(),
        previousValue: z.number(),
    }),
    buyers: z.object({
        currentValue: z.number(),
        previousValue: z.number(),
    }),
    sellers: z.object({
        currentValue: z.number(),
        previousValue: z.number(),
    }),
    traders: z.object({
        currentValue: z.number(),
        previousValue: z.number(),
    }),
});
const TDefinedAggregatedPairInfo = z.object({
    stats_min5: TPairInfoStatsSchema,
    stats_hour1: TPairInfoStatsSchema,
    stats_hour4: TPairInfoStatsSchema,
    stats_hour12: TPairInfoStatsSchema,
    stats_day1: TPairInfoStatsSchema,
});
export const TBasicTokenInfoSchema = z.object({
    token: TokenInfoSchema,
    tokenInfo: z.object({
        results: z.array(FilterTokenResultSchema),
    }),
    prices: TokenPriceSchema,
    tokenStats: TDefinedAggregatedPairInfo.nullish(),
});
export const CovalentBalanceItemSchema = z.object({
    contract_decimals: z.number().nullish(),
    contract_name: z.string().nullish(),
    contract_ticker_symbol: z.string().nullish(),
    contract_address: z.string().nullish(),
    contract_display_name: z.string().nullish(),
    logo_url: z.string().nullish(),
    last_transferred_at: z.string().nullish(),
    native_token: z.boolean().nullish(),
    type: z.enum(['cryptocurrency', 'stablecoin', 'nft', 'dust']).nullish(),
    is_spam: z.boolean().nullish(),
    balance: z.string().nullish(),
    balance_24h: z.union([z.string(), z.number()]).nullish(),
    quote_rate: z.number().nullish(),
    quote_rate_24h: z.number().nullish(),
    quote: z.number().nullish(),
    quote_24h: z.number().nullish(),
    pretty_quote: z.string().nullish(),
    pretty_quote_24h: z.string().nullish(),
    network: z.number().nullish(),
    network_name: z.string().nullish(),
    formatted_balance: z.number().nullish(),
    usd_value: z.number().nullish(),
    logo_urls: z
        .object({
        token_logo_url: z.string().nullish(),
        protocol_logo_url: z.string().nullish(),
        chain_logo_url: z.string().nullish(),
    })
        .nullish(),
    // Additional fields
    percentage: z.number().nullish(),
    amountToUse: z.number().nullish(),
    amountToUseStr: z.string().nullish(),
});
